import type { ReactNode } from 'react';
import { Icon } from './Icon';

export function Notice({
  tone = 'info',
  title,
  children,
  action,
  onDismiss,
  testId,
}: {
  tone?: 'info' | 'warn' | 'danger';
  title: string;
  children?: ReactNode;
  action?: ReactNode;
  onDismiss?: () => void;
  testId?: string;
}) {
  return (
    <div className={`notice notice-${tone}`} role={tone === 'danger' ? 'alert' : 'note'} data-testid={testId}>
      <span className="notice-icon">
        <Icon name={tone === 'info' ? 'info' : 'warn'} size={18} />
      </span>
      <div className="notice-body">
        <strong>{title}</strong>
        {children ? <div className="notice-text">{children}</div> : null}
        {action ? <div className="notice-action">{action}</div> : null}
      </div>
      {onDismiss ? (
        <button type="button" className="icon-btn ghost notice-close" onClick={onDismiss} aria-label="Chiudi avviso">
          <Icon name="close" size={14} />
        </button>
      ) : null}
    </div>
  );
}
